import React, { useState, useEffect, useMemo } from "react";
import danger from "../images/Danger.png";
import catalogoEmojis from "../images/catalogo-emojis-new.webp";
import { useDataContext } from "../contexts/AuthContext";
import Swal from "sweetalert2";
import {
  uploadSize,
  getSizes,
  getUserSizes,
  prendasCadaUsuario,
  getPaymentInformation,
  getSizesByOrderId,
} from "../services/api";
import { useNavigate } from "react-router-dom";
import GuiaTallesModal from "./GuiaTallesModal";
import styles from "../styles/SizeFlow.module.css";
import {
  EmojiTipsCard,
  SizeAlertBanner,
  SizeConfirmationModal,
  SizeField,
  SizeFlowShell,
  SizeFooter,
  SizeProductSummary,
  SizeSections,
} from "./SizeFlowShared";

const Talles = ({ orderItemId, onClose, prenda, prendasConPath, moldingId, orderItemCategoryId }) => {
  const navigate = useNavigate();
  const [alumno, setAlumno] = useState("");
  const [selectedAlumno, setSelectedAlumno] = useState("");
  const [apodo, setApodo] = useState("");
  const [personalizado, setPersonalizado] = useState("");
  const [emojiOpen, setEmojiOpen] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const { contextData } = useDataContext();
  const [isConfirming, setIsConfirming] = useState(false);
  const { customer } = contextData;
  const customer_id = customer.id;
  const [items, setItems] = useState([]);
  const [tallesCargados, setTallesCargados] = useState({});
  const [disableEnviar, setDisableEnviar] = useState(false);
  const [countCustomerOrderItem, setCountCustomerOrderItem] = useState(0);
  const [countOrderItemPaxes, setCountOrderItemPaxes] = useState(0);
  const [tallesPorMolderia, setTallesPorMolderia] = useState({});
  const [visibilidadMolderia, setVisibilidadMolderia] = useState({});
  const [tallesSeleccionados, setTallesSeleccionados] = useState({});
  const [molderiaModalAbierta, setMolderiaModalAbierta] = useState(null);

  // Solo el TUTOR (3) carga en modo multi-alumno. El delegado (2) carga SUS talles
  // (como un usuario normal); para los compañeros usa el formulario / import de Excel.
  const isTutorLike = customer.customer_type === 3;

  const abrirModalMolderia = (molderia) => setMolderiaModalAbierta(molderia);
  const cerrarModalMolderia = () => setMolderiaModalAbierta(null);

  useEffect(() => {
    const fetchSizes = async () => {
      try {
        const data = await getSizesByOrderId(customer.order_id, moldingId, orderItemCategoryId);
        setTallesPorMolderia(data);
        const visibilidadInicial = {};
        const seleccionInicial = {};
        Object.keys(data).forEach((molderia) => {
          visibilidadInicial[molderia] = false;
          seleccionInicial[molderia] = data[molderia].map(() => false);
        });
        setVisibilidadMolderia(visibilidadInicial);
        setTallesSeleccionados(seleccionInicial);
      } catch (error) {
        console.error("Error al obtener talles dinámicos:", error);
      }
    };

    fetchSizes();
  }, [customer.order_id, moldingId, orderItemCategoryId]);

  const toggleSeccion = (molderia) => {
    setVisibilidadMolderia((prev) => ({
      ...prev,
      [molderia]: !prev[molderia],
    }));
  };

  const handleTalleChange = (molderia, index) => {
    const nuevoEstado = {};

    Object.keys(tallesSeleccionados).forEach((mol) => {
      if (mol === molderia) {
        nuevoEstado[mol] = tallesSeleccionados[mol].map((_, i) => i === index);
      } else {
        nuevoEstado[mol] = tallesSeleccionados[mol].map(() => false);
      }
    });

    setTallesSeleccionados(nuevoEstado);
  };

  const obtenerTallesSeleccionados = () => {
    const codigos = [];
    let talleSeleccionado = null;

    Object.entries(tallesSeleccionados).forEach(([molderia, seleccionados]) => {
      if (!Array.isArray(seleccionados)) return;

      seleccionados.forEach((isSelected, index) => {
        if (isSelected) {
          const talle = tallesPorMolderia[molderia]?.[index];
          if (talle) {
            codigos.push(talle.code);
            if (!talleSeleccionado) {
              talleSeleccionado = talle;
            }
          }
        }
      });
    });

    return {
      codigos,
      width: talleSeleccionado?.max_width ?? null,
      height: talleSeleccionado?.max_height ?? null,
    };
  };

  const obtenerTallesSeleccionadosPorMolderia = () => {
    const resultado = {};

    Object.entries(tallesSeleccionados).forEach(([molderia, seleccionados]) => {
      seleccionados.forEach((isSelected, index) => {
        if (isSelected) {
          const talle = tallesPorMolderia[molderia][index];
          if (talle) {
            if (!resultado[molderia]) {
              resultado[molderia] = [];
            }
            resultado[molderia].push(talle.code);
          }
        }
      });
    });

    return resultado;
  };

  useEffect(() => {
    if (!customer || !customer.customer_type || !customer.first_name) {
      return;
    }
    if (isTutorLike) {
      prendasCadaUsuario(contextData.customer.lead_id, orderItemId)
        .then((users) => {
          setAllUsers(users);
          if (users.length > 0) {
            setSelectedAlumno(users[0].id);
            setAlumno(`${users[0].first_name ?? ""} ${users[0].last_name ?? ""}`.trim());
          }
        })
        .catch((error) => console.error("Error al obtener usuarios:", error));
    } else {
      setAllUsers([]);
      setAlumno(`${customer.first_name ?? ""} ${customer.last_name ?? ""}`.trim());
    }
  }, [customer, isTutorLike, contextData.customer.lead_id, orderItemId]);

  const handleAlumnoChange = (e) => setAlumno(e.target.value);

  const handleSelectedAlumnoChange = async (e) => {
    const selectedUserId = parseInt(e.target.value);
    setSelectedAlumno(selectedUserId);

    const selectedUser = allUsers.find((user) => user.id === selectedUserId);

    if (selectedUser) {
      setAlumno(`${selectedUser.first_name ?? ""} ${selectedUser.last_name ?? ""}`.trim());

      try {
        const data = await getUserSizes(selectedUserId, orderItemId);
        const userTallesCargados = data.filter(
          (item) => item.customer_id === selectedUserId && item.order_item_id === orderItemId
        );

        const countTallesCargadosAlumno = userTallesCargados.length;
        setTallesCargados((prev) => ({
          ...prev,
          [prenda]: countTallesCargadosAlumno,
        }));
      } catch (error) {
        console.error("Error al obtener talles cargados:", error);
      }
    } else {
      setAlumno("");
    }
  };

  const uploadSizes = async (e) => {
    e.preventDefault();
    setIsConfirming(true);

    if (!customer_id) {
      console.error("customer_id no está disponible");
      setIsConfirming(false);
      return;
    }

    const { codigos, width, height } = obtenerTallesSeleccionados();
    if (!Array.isArray(codigos) || codigos.length === 0) {
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atención",
        text: "Debes seleccionar un talle.",
      });
      setIsConfirming(false);
      return;
    } else if (alumno === "") {
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atención",
        text: "Debes seleccionar un alumno.",
      });
      setIsConfirming(false);
      return;
    }

    const data = {
      name: alumno,
      nickname: apodo,
      initials: personalizado,
      comments: null,
      gender: "f",
      width,
      height,
      size: codigos.join(","),
      order_item_id: orderItemId,
      created_by_id: customer_id,
      customer_id: isTutorLike ? selectedAlumno : customer_id,
    };

    try {
      await uploadSize(data);

      // ¿Cuántas unidades de esta prenda hay y cuántas quedan? Si faltan, NO salimos:
      // limpiamos el form y avisamos "unidad N de total" para cargar la siguiente.
      const totalUnidades = isTutorLike
        ? (countCustomerOrderItem || 0)
        : (items.find((i) => i.name === prenda)?.quantity || 0);
      const cargadasPrevias = isTutorLike
        ? (countOrderItemPaxes || 0)
        : (tallesCargados[prenda] || 0);
      const yaCargadas = cargadasPrevias + 1;

      actualizarTallesCargados(prenda);
      setShowModal(false);

      if (totalUnidades > 1 && yaCargadas < totalUnidades) {
        // Reset para la próxima unidad (apodo, personalizado y selección de talle).
        setApodo("");
        setPersonalizado("");
        setTallesSeleccionados((prev) => {
          const limpio = {};
          Object.keys(prev).forEach((m) => {
            limpio[m] = Array.isArray(prev[m]) ? prev[m].map(() => false) : prev[m];
          });
          return limpio;
        });
        Swal.fire({
          icon: "success",
          iconColor: "#22c55e",
          confirmButtonColor: "#0071ce",
          title: `Talle ${yaCargadas} de ${totalUnidades} cargado`,
          text: `Ahora cargá la unidad ${yaCargadas + 1} de ${totalUnidades} de ${prenda}.`,
        });
      } else {
        // Última unidad cargada: volvemos a la sección Talles (onClose refresca la lista).
        Swal.fire({
          icon: "success",
          iconColor: "#22c55e",
          confirmButtonColor: "#0071ce",
          title: "¡Talles cargados!",
          text: `Completaste los talles de ${prenda}.`,
        }).then(() => {
          if (typeof onClose === "function") onClose();
          else navigate("/mcb/talles");
        });
      }
    } catch (error) {
      console.error("Error al crear el talle:", error.message);
      Swal.fire({
        icon: "error",
        title: "Error al cargar talles",
        text: "Hubo un problema al cargar los talles. Por favor, intenta de nuevo más tarde.",
      });
    } finally {
      setIsConfirming(false);
    }
  };

  const handleApodoChange = (e) => setApodo(e.target.value);
  const handlePersonalizadoChange = (e) => setPersonalizado(e.target.value);
  const toggleEmojiMenu = () => setEmojiOpen(!emojiOpen);

  const handleEnviarClick = (e) => {
    e.preventDefault();

    const algunTalleSeleccionado = Object.values(tallesSeleccionados).some((talles) =>
      talles.some((checked) => checked)
    );

    if (!algunTalleSeleccionado) {
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atención",
        text: "Debes seleccionar al menos un talle.",
      });
    } else if (alumno === "") {
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atención",
        text: "Debes seleccionar un alumno.",
      });
    } else {
      setShowModal(true);
    }
  };

  useEffect(() => {
    if (isTutorLike) {
      const cantidadTotal = countCustomerOrderItem;
      const cantidadCargada = countOrderItemPaxes;
      setDisableEnviar(cantidadCargada >= cantidadTotal);
    } else {
      const cantidadTotal = items.find((item) => item.name === prenda)?.quantity || 0;
      const cantidadCargada = tallesCargados[prenda] || 0;
      setDisableEnviar(cantidadCargada >= cantidadTotal);
    }
  }, [tallesCargados, prenda, items, countCustomerOrderItem, countOrderItemPaxes, isTutorLike]);

  const handleCancelarEnviar = () => setShowModal(false);

  const actualizarTallesCargados = (nombreItem) => {
    setTallesCargados((prev) => ({
      ...prev,
      [nombreItem]: (prev[nombreItem] || 0) + 1,
    }));
  };

  useEffect(() => {
    const fetchTallesCargados = async () => {
      try {
        let data;
        if (isTutorLike) {
          data = await getUserSizes(selectedAlumno, orderItemId);

          if (data.length > 0) {
            setCountCustomerOrderItem(data[0].countCustomerOrderItem || 0);
            setCountOrderItemPaxes(data[0].countOrderItemPaxes || 0);
          }
        } else {
          data = await getSizes(orderItemId);
        }

        const currentUserTalles = data.filter(
          (item) =>
            item.customer_id === (isTutorLike ? selectedAlumno : contextData.customer.id) &&
            item.order_item_id === orderItemId
        );
        const countTallesCargados = currentUserTalles.length;

        setTallesCargados((prev) => ({
          ...prev,
          [prenda]: countTallesCargados,
        }));
      } catch (error) {
        console.error("Error al obtener talles cargados:", error);
      }
    };

    fetchTallesCargados();
  }, [orderItemId, prenda, contextData.customer.id, selectedAlumno, isTutorLike]);

  useEffect(() => {
    getPaymentInformation(contextData.customer.id, contextData.customer.order_id)
      .then((data) => {
        setItems(data.items);
      })
      .catch((error) => {
        console.log("Error en la solicitud de información de pago", error);
      });
  }, [contextData.customer.id, contextData.customer.order_id]);

  const selectedProduct = useMemo(
    () => prendasConPath.filter((prendaItem) => prendaItem.product_name === prenda)[0] || null,
    [prendasConPath, prenda]
  );

  const cantidadTotal = items.find((item) => item.name === prenda)?.quantity || 0;
  const cantidadCargada = tallesCargados[prenda] || 0;
  const subtitle = isTutorLike
    ? "Seleccioná al alumno, completá apodo y elegí el talle correspondiente para cada unidad pendiente."
    : cantidadTotal > 1
      ? `Pediste ${cantidadTotal} unidades de ${prenda}: cargás el talle de a una. Vas ${cantidadCargada} de ${cantidadTotal}.`
      : "Completá los datos de la prenda y elegí el talle correcto antes de enviarlo.";

  const summaryMetrics = isTutorLike
    ? [
        { label: "Cantidad seleccionada", value: countCustomerOrderItem || 0 },
        { label: "Talles cargados", value: countOrderItemPaxes || 0 },
      ]
    : [
        { label: "Cantidad total", value: cantidadTotal || 0 },
        { label: "Cargados", value: `${cantidadCargada}/${cantidadTotal || 0}` },
      ];

  return (
    <>
      <SizeFlowShell
        title="Cargar"
        titleAccent="talles"
        subtitle={subtitle}
        eyebrow="Formulario de talles"
        onClose={onClose}
      >
        <SizeProductSummary
          title={selectedProduct?.product_name || prenda}
          alias={selectedProduct?.alias || ""}
          metrics={summaryMetrics}
        />

        <SizeAlertBanner
          icon={danger}
          title={
            cantidadTotal > 1
              ? `Estás cargando la unidad ${Math.min(cantidadCargada + 1, cantidadTotal)} de ${cantidadTotal}`
              : "Antes de enviar, revisá que todo coincida"
          }
          text={
            cantidadTotal > 1
              ? `Cargá el talle de cada unidad de ${prenda}, una a la vez. Al guardar, te vamos a pedir la siguiente hasta completar las ${cantidadTotal}.`
              : "Revisá que el talle elegido coincida con la guía antes de enviarlo."
          }
        />

        <div className={styles.fieldCard}>
          <span className={styles.cardEyebrow}>Datos de la prenda</span>
          <p className={styles.cardTitle}>Completá la información básica</p>
          <div className={`${styles.fieldGrid} ${styles.fieldGridTwo}`}>
            {isTutorLike ? (
              <SizeField label="Alumno">
                <select
                  className={styles.select}
                  id="selectedAlumno"
                  name="selectedAlumno"
                  value={selectedAlumno}
                  onChange={handleSelectedAlumnoChange}
                >
                  {allUsers.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.first_name} {user.last_name}
                    </option>
                  ))}
                </select>
              </SizeField>
            ) : (
              <SizeField label="Alumno">
                <input
                  name="name"
                  type="text"
                  className={styles.input}
                  id="alumno"
                  value={alumno}
                  onChange={handleAlumnoChange}
                />
              </SizeField>
            )}

            <SizeField label="Apodo" hint="Si no querés que lleve apodo, podés dejar este campo vacío.">
              <input
                name="nickname"
                type="text"
                className={styles.input}
                id="apodo"
                value={apodo}
                onChange={handleApodoChange}
              />
            </SizeField>

            <SizeField
              label="Personalizado"
              hint="Aclará modalidad, opcionales o números personalizados si la prenda lleva algo extra."
            >
              <textarea
                name="comments"
                className={styles.textarea}
                id="personalizado"
                value={personalizado}
                onChange={handlePersonalizadoChange}
              />
            </SizeField>
          </div>
        </div>

        <EmojiTipsCard emojiOpen={emojiOpen} onToggle={toggleEmojiMenu} image={catalogoEmojis} />

        <SizeSections
          title="Elegí el talle correcto"
          hint="Si pediste 2 o más unidades de {prenda}, cargá el talle para cada una antes de enviar."
          prenda={prenda}
          tallesPorMolderia={tallesPorMolderia}
          visibilidadMolderia={visibilidadMolderia}
          tallesSeleccionados={tallesSeleccionados}
          onToggleSeccion={toggleSeccion}
          onTalleChange={handleTalleChange}
          onOpenGuide={abrirModalMolderia}
        />

        <SizeFooter onBack={onClose} onSubmit={handleEnviarClick} submitLabel="Enviar" disabled={disableEnviar} />
      </SizeFlowShell>

      {molderiaModalAbierta ? (
        <GuiaTallesModal
          order_id={customer.order_id}
          molderia={molderiaModalAbierta}
          onClose={cerrarModalMolderia}
        />
      ) : null}

      <SizeConfirmationModal
        open={showModal}
        title="¿Confirmás que los datos ingresados son correctos?"
        subtitle="Revisá alumno, apodo, personalizado y talle antes de enviarlo."
        alumno={alumno}
        apodo={apodo}
        personalizado={personalizado}
        tallesPorMolderia={obtenerTallesSeleccionadosPorMolderia()}
        onClose={handleCancelarEnviar}
        onConfirm={uploadSizes}
        confirmLabel={isConfirming ? "Confirmando" : "Confirmar"}
        confirmLoading={isConfirming}
      />
    </>
  );
};

export default Talles;
